module.exports = __webpack_public_path__ + "img/expostyle_0962_theatre_red.e0c54cc1.jpg";